<template>

  <div id="accordionExample">
        <b-table-simple bordered>
        <b-thead class="entete">
          <b-tr>
            <b-th>n° Anomalie</b-th>
            <b-th>Anomalie</b-th>
            <b-th>Justification</b-th>
            <b-th>Type</b-th>
            <b-th>Validation</b-th>
          </b-tr>
        </b-thead>
          <b-tbody class="corps-tableau">
            <b-tr v-for="anomalie in anomalies"
                  v-bind:key="anomalie.idAnomalie"
                  v-bind:anomalie="anomalie">
              <b-td> {{anomalie.idAnomalie}}</b-td>
              <b-td style="max-width: 400px">{{anomalie.message}}</b-td>
              <b-td>{{anomalie.justification}}</b-td>
              <b-td>{{anomalie.type}}</b-td>
              <b-td v-if="anomalie.validation == 1" style="color: forestgreen; max-width: 400px">Validé</b-td>
              <b-td v-else-if="anomalie.validation == 0" style="max-width: 400px">
                <p style="color: red"> Refusé</p>
                <p @click="toggleComment(anomalie.idAnomalie)" style="text-decoration: underline; cursor: pointer">Voir le commentaire</p>
                <div v-show="showComments[anomalie.idAnomalie]">
                  <p v-if="anomalie.commentaire != null"><strong>{{anomalie.commentaire}}</strong></p>
                  <p v-else><strong>Pas de commentaire pour cette anomalie</strong></p>
                  <p @click="toggleEdit(anomalie.idAnomalie)" style="text-decoration: underline; cursor: pointer">Modifier le commentaire</p>
                  <div v-show="editComments[anomalie.idAnomalie]">
                    <b-form-group class="labelTitre" id="input-group-10" label-for="input-10">
                      <b-form-input id="input-10" v-model="commentaire" type="text"></b-form-input>
                    </b-form-group>
                    <b-button pill @click="ValidJustif(0,commentaire,anomalie.idAnomalie)" class="nav-link1 m-2">Valider</b-button>
                  </div>
                </div>
              </b-td>
              <b-td v-else><b-button pill v-on:click="ValidJustif(1,'Justification',anomalie.idAnomalie)">Oui</b-button> <b-button pill @click.prevent ="showModalRefusAnomalie = !showModalRefusAnomalie ">Non</b-button></b-td>

              <b-modal v-model="showModalRefusAnomalie" hide-header hide-footer centered>
                <b-form-group class="labelTitre" id="input-group-10" label="Veuillez commenter votre refus " label-for="input-10">
                  <b-form-input id="input-10" v-model="commentaire" type="text"></b-form-input>
                </b-form-group>

                <b-button pill @click="ValidJustif(0,commentaire,anomalie.idAnomalie);$bvModal.hide('my-modal16'+ anomalie.idAnomalie)" class="nav-link1 m-2">Valider</b-button>
                <b-button pill id="close" class="nav-link2 m-2" @click="showModalRefusAnomalie = false">Annuler</b-button>
              </b-modal>

            </b-tr>
          </b-tbody>
        </b-table-simple>

  </div>

</template>

<script>
import useJustificationItem from "@/composition/Rapports/justifications";

export default {
  name: 'JustificationItem',

  props: {
    anomalies:{
      required:true,
      type:Array
    },
    idExecution:{
      type:Number
    }
},


  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    return useJustificationItem();
  },
};
</script>

<style>
.entete{
  font-size: 13px;
  background-color: silver;
  text-align : center;
}

.corps-tableau{
  font-size: 13px;
  text-align : center;
  background-color: white;
}

.table td{
  vertical-align: middle;
}
</style>